const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://weather-backend-879484113802.us-central1.run.app/api';

export interface TripDestination {
  location: string;
  country: string;
  state?: string;
  latitude: number;
  longitude: number;
  weatherScore: number;
  summary: string;
  details: {
    averageHigh: number;
    averageLow: number;
    rainChance: number;
    conditions: string;
  };
}

export interface BestTimeResult {
  location: string;
  bestMonths: Array<{
    month: string;
    monthNumber: number;
    weatherScore: number;
    averageHigh: number;
    averageLow: number;
    rainChance: number;
    summary: string;
  }>;
  worstMonths: string[];
  yearRoundSummary: string;
}

class TripPlanningApiService {
  async findDestinationsForDates(
    startDate: string,
    endDate: string,
    preferences: {
      temperature: 'hot' | 'warm' | 'cool' | 'cold';
      precipitation: 'dry' | 'occasional-rain' | 'regular-rain';
      goal: 'avoid-rain' | 'warm-weather' | 'cool-weather' | 'mild-weather';
    }
  ): Promise<{ success: boolean; data: TripDestination[] }> {
    console.log('Finding destinations for dates:', { startDate, endDate, preferences });
    
    const response = await fetch(`${API_BASE_URL}/trip-planning/find-destinations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ startDate, endDate, preferences, goal: preferences.goal }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async findBestTimeToVisit(location: string): Promise<{ success: boolean; data: BestTimeResult }> {
    console.log('Finding best time to visit:', location);
    
    const response = await fetch(`${API_BASE_URL}/trip-planning/find-best-time`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ location, goal: 'mild-weather' }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}

export const tripPlanningApi = new TripPlanningApiService();